import { TextField, Paper, Button, FormGroup, FormControlLabel, Switch, Alert } from "@mui/material";
import SelectUser from "./SelectUser";
import { useState, useEffect } from "react";
import axios from "axios";
import CompanySelect from "../Universal/CompanySelect";
import LockResetIcon from '@mui/icons-material/LockReset';
import CompanyAutoselect from "../Universal/CompanyAutoselect";


function EditUsers(props) {
    //Managing all users in this unit because someone could have added a user and I would need to retrieve them from the database
    const [allUsers, setAllUsers] = useState([{}]);
    const [userId, setUserId] = useState(0);
    const [selectedCompany, setSelectedCompany] = useState(0);
    const [selectedUser, setSelectedUser] = useState({ isActive: false });
    const [newPassword, setNewPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [resetSuccess, setResetSuccess] = useState('');
    const [resetError, setResetError] = useState('');

    //When the component gets mounted go ahead and refresh all users
    useEffect(() => {
        //Load up the companies
        axios({
            // Endpoint to send files
            url: process.env.REACT_APP_API_URL + 'User',
            method: "Get",
            data: {},
        }).then((res) => {
            setAllUsers(res.data);
        }).catch((err) => {
            console.log(err)
        });
    }, []);

    //useEffect to capture when user is selected so I can update a variety of values
    useEffect(() => {
        console.log(props.allCompanies)
        //Find the user
        let usr = allUsers.find((u) => u.cerptsUserId === userId);
        console.log('Selected user:', usr);
        console.log('User companyId:', usr?.companyId);
        if (usr !== null && usr !== undefined && usr.companyId !== null && usr.companyId !== undefined) {
            //Update selected Company
            console.log('Setting selectedCompany to:', usr.companyId);
            setSelectedCompany(usr.companyId);
            setSelectedUser(usr);
        }
        else {
            console.log('Setting selectedCompany to 0');
            setSelectedCompany(0);
            setSelectedUser({ isActive: false });
        }
    }, [userId, allUsers]);

    const resetPassword = () => {
        // Validate password
        if (!newPassword.trim()) {
            setPasswordError('Password is required');
            return;
        }
        
        if (newPassword.length < 5) {
            setPasswordError('Password must be at least 5 characters long');
            return;
        }

        // Clear any previous messages
        setPasswordError('');
        setResetSuccess('');
        setResetError('');

        // Create Login object with Email and Password
        const loginData = {
            email: selectedUser.email,
            password: newPassword
        };

        // Make API call to adminReset endpoint
        axios({
            url: process.env.REACT_APP_API_URL + 'adminReset',
            method: "POST",
            data: loginData,
        }).then((res) => {
            setResetSuccess('Password reset successfully!');
            setNewPassword(''); // Clear the password field
            // Clear success message after 3 seconds
            setTimeout(() => setResetSuccess(''), 3000);
        }).catch((err) => {
            console.log(err);
            let errorMessage = 'Failed to reset password. Please try again.';
            
            if (err.response) {
                if (err.response.status === 400) {
                    errorMessage = 'Invalid data provided. Please check the password.';
                } else if (err.response.status === 401) {
                    errorMessage = 'Authentication failed. Please log in again.';
                } else if (err.response.status === 403) {
                    errorMessage = 'You do not have permission to reset passwords.';
                } else if (err.response.status === 500) {
                    errorMessage = 'Server error occurred. Please try again later.';
                } else if (err.response.data && err.response.data.message) {
                    errorMessage = err.response.data.message;
                }
            } else if (err.request) {
                errorMessage = 'Network error. Please check your connection and try again.';
            }
            
            setResetError(errorMessage);
            // Clear error message after 5 seconds
            setTimeout(() => setResetError(''), 5000);
        });
    }

    const changeUsercCompany = (newValue) => {
        setSelectedUser({ ...selectedUser, companyId: newValue.id });
    }

    const saveChanges = () => {
        console.log(selectedUser);
        axios({
            // Endpoint to send files
            url: process.env.REACT_APP_API_URL + 'User',
            method: "Put",
            data: { ...selectedUser },
        }).then((res) => {
            //Do nothing?
            setUserId(0);//this should reset my interface
            //I also need to replace the user with this new user
            setAllUsers(allUsers.map((u) => u.cerptsUserId === res.data.cerptsUserId ? res.data : u));
        }).catch((err) => {
            console.log(err)
        });
    }


    return (
        <>
            <div className="container">
                <h4>Edit User</h4>
                <div className='formRow'>
                    <div className='formGroup'>
                        <SelectUser className="formControl" allUsers={allUsers} setAllUsers={setAllUsers} userId={userId} setUserId={setUserId}></SelectUser>
                    </div>
                    <div className='formGroup'></div>
                    <div className='formGroup'></div>
                </div>
                <div className='formRow'>
                    <div className="formGroup">
                        <CompanyAutoselect headerText='' selectText='Select Company' selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} allCompanies={props.allCompanies} showAllCompanies={true} onChange={changeUsercCompany} />
                    </div>
                    <div className="formGroup"></div>
                    <div className="formGroup"></div>
                </div>

                <div className="formRow">
                    <div className="formGroup">
                        <FormGroup>
                            <FormControlLabel control={<Switch checked={selectedUser.isActive} onChange={(e) => setSelectedUser({ ...selectedUser, isActive: e.target.checked })} />} label="Active"></FormControlLabel>
                        </FormGroup>
                    </div>
                    <div className="formGroup">

                    </div>
                    <div className="formGroup"></div>
                </div>

                {/* Password Reset Section */}
                <div className="formRow">
                    <div className="formGroup">
                        <TextField
                            label="New Password"
                            type="password"
                            value={newPassword}
                            onChange={(e) => {
                                setNewPassword(e.target.value);
                                if (passwordError) setPasswordError(''); // Clear error when typing
                            }}
                            placeholder="Enter new password"
                            variant="outlined"
                            size="small"
                            error={!!passwordError}
                            helperText={passwordError || 'Enter a new password for the user (min 6 characters)'}
                            sx={{ minWidth: '250px' }}
                        />
                    </div>
                    <div className="formGroup">
                        <Button 
                            variant='outlined' 
                            startIcon={<LockResetIcon />} 
                            size="small" 
                            onClick={resetPassword}
                            disabled={!newPassword.trim()}
                        >
                            Reset Password
                        </Button>
                    </div>
                    <div className="formGroup"></div>
                </div>

                {/* Success/Error Messages */}
                {resetSuccess && (
                    <div className="formRow">
                        <div className="formGroup">
                            <Alert severity="success" sx={{ width: '100%' }}>
                                {resetSuccess}
                            </Alert>
                        </div>
                    </div>
                )}
                
                {resetError && (
                    <div className="formRow">
                        <div className="formGroup">
                            <Alert severity="error" sx={{ width: '100%' }}>
                                {resetError}
                            </Alert>
                        </div>
                    </div>
                )}

                <div className="formRow">
                    <div className="formGroup">
                        <Button variant='outlined' onClick={saveChanges} size="small">Save</Button>
                    </div>
                    <div className="formGroup">

                    </div>
                    <div className="formGroup"></div>
                </div>


            </div>
        </>
    );
}

export default EditUsers;